import React from "react";
import { Props } from "../types";

function ListIcon(props: Props) {
  return (
    <svg
      viewBox="0 -3 21 21"
      fill="currentColor"
      className={props.className}
      style={props.style}
    >
      <g transform="translate(-219.000000, -322.000000)">
        <g transform="translate(56.000000, 160.000000)">
          <path d="M163,177 L166.15,177 L166.15,174 L163,174 L163,177 Z M168.25,177 L184,177 L184,175 L168.25,175 L168.25,177 Z M163,171 L166.15,171 L166.15,168 L163,168 L163,171 Z M168.25,171 L184,171 L184,169 L168.25,169 L168.25,171 Z M163,165 L166.15,165 L166.15,162 L163,162 L163,165 Z M168.25,165 L184,165 L184,163 L168.25,163 L168.25,165 Z" />
        </g>
      </g>
    </svg>
  );
}

export { ListIcon };
